var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 15.2787C4.5 14.6938 4.95 14.2154 5.5 14.2154C6.05 14.2154 6.5 14.6938 6.5 15.2787C6.5 15.8635 6.05 16.3419 5.5 16.3419C4.95 16.3419 4.5 15.8635 4.5 15.2787ZM9.5 14.2154H13.5C14.05 14.2154 14.5 14.6938 14.5 15.2787C14.5 15.8635 14.05 16.3419 13.5 16.3419H9.5C8.95 16.3419 8.5 15.8635 8.5 15.2787C8.5 14.6938 8.95 14.2154 9.5 14.2154ZM15.5 19.5318H3.5C2.949 19.5318 2.5 19.0544 2.5 18.4685V12.0888H16.5V18.4685C16.5 19.0544 16.051 19.5318 15.5 19.5318ZM3.5 4.64574H4.5V5.70903C4.5 6.29384 4.95 6.77232 5.5 6.77232C6.05 6.77232 6.5 6.29384 6.5 5.70903V4.64574H12.5V5.70903C12.5 6.29384 12.95 6.77232 13.5 6.77232C14.05 6.77232 14.5 6.29384 14.5 5.70903V4.64574H15.5C16.051 4.64574 16.5 5.12316 16.5 5.70903V9.9622H2.5V5.70903C2.5 5.12316 2.949 4.64574 3.5 4.64574ZM15.5 2.51916H14.5V1.45587C14.5 0.871059 14.05 0.392578 13.5 0.392578C12.95 0.392578 12.5 0.871059 12.5 1.45587V2.51916H6.5V1.45587C6.5 0.871059 6.05 0.392578 5.5 0.392578C4.95 0.392578 4.5 0.871059 4.5 1.45587V2.51916H3.5C1.846 2.51916 0.5 3.95035 0.5 5.70903V18.4685C0.5 20.2272 1.846 21.6584 3.5 21.6584H15.5C17.154 21.6584 18.5 20.2272 18.5 18.4685V5.70903C18.5 3.95035 17.154 2.51916 15.5 2.51916Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2ff29840c8a533873878b3b96a1a7728.svg";
export { ForwardRef as ReactComponent };